module.exports = __webpack_public_path__ + "static/media/Blind Spot.082ad991.svg";